const secsOfMinate = 60;
const secsOfHour = 3600;
const secsOfDay = 86400;
const secsOfMonth = 2592000;
const secsOfYear = 31104000;

const timeline = (stamp) => {

  if (!stamp) return '';

  // stamp = stamp.replace(/-/g, '/');

  const time = Date.parse(stamp);
  const timeNow = Date.parse(new Date());

  const timeMargin = (timeNow - time) / 1000;

  // alert('timeMargin: ' + timeMargin)
  // alert('time' + new Date(stamp))
  // alert(time)
  // alert('timeNow' + timeNow)

  if (timeMargin < secsOfMinate) {
    return '刚刚';
  } if (timeMargin < secsOfHour) {
    return `${Math.floor(timeMargin / secsOfMinate)}分钟前`;
  } else if (timeMargin < secsOfDay) {
    return `${Math.floor(timeMargin / secsOfHour)}小时前`;
  } else if (timeMargin < secsOfMonth) {
    return `${Math.floor(timeMargin / secsOfDay)}天前`;
  } else if (timeMargin < secsOfYear) {
    return `${Math.floor(timeMargin / secsOfMonth)}月前`;
  } else {
    return `${Math.floor(timeMargin / secsOfYear)}年前`;
  }

}

export default timeline;